/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChangePasswordBody,
  GetAvatarsPayload,
  GetAvatarsViewModel,
  GetListParams,
  SetLocaleUserBody,
  UpdateAvatarParams,
  UpdateProfileBody,
  UserFilter,
  UserGet,
  UserViewModel,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Users<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Users
   * @name UsersDetail
   * @summary Получить пользователей по идентификатору
   * @request GET:/users/{userId}
   * @secure
   * @response `200` `UserGet` Пользователь по идентификатору
   */
  usersDetail = (userId: string, params: RequestParams = {}) =>
    this.request<UserGet, any>({
      path: `/users/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetList
   * @summary Получить список пользователей
   * @request POST:/users/list
   * @secure
   * @response `200` `(UserGet)[]` Список пользователей
   */
  getList = (query: GetListParams, data: UserFilter, params: RequestParams = {}) =>
    this.request<UserGet[], any>({
      path: `/users/list`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CreateUser
   * @summary Создание пользователя
   * @request POST:/users/create
   * @secure
   * @response `200` `void` Success
   */
  createUser = (data: UserViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUser
   * @summary Обновление пользователя
   * @request POST:/users/{userId}/update
   * @secure
   * @response `200` `void` Success
   */
  updateUser = (userId: string, data: UserViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/${userId}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetLocaleUser
   * @summary Обновление языка пользователя
   * @request POST:/users/{userId}/setLocaleUser
   * @secure
   * @response `200` `void` Success
   */
  setLocaleUser = (userId: string, data: SetLocaleUserBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/${userId}/setLocaleUser`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name Delete
   * @summary Удаление пользователя
   * @request POST:/users/{id}/delete
   * @secure
   * @response `200` `void` Success
   */
  delete = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/${id}/delete`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetAvatar
   * @summary Получение аватара пользователя
   * @request GET:/users/{userId}/getAvatar
   * @secure
   * @response `200` `string` Аватар пользователя
   */
  getAvatar = (userId: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/users/${userId}/getAvatar`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetAvatars
   * @summary Получение аватарок пользователей
   * @request POST:/users/getAvatars
   * @secure
   * @response `200` `(GetAvatarsViewModel)[]` Аватарки ользователей
   */
  getAvatars = (data: GetAvatarsPayload, params: RequestParams = {}) =>
    this.request<GetAvatarsViewModel[], any>({
      path: `/users/getAvatars`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateAvatar
   * @request POST:/users/{userId}/updateAvatar
   * @secure
   * @response `200` `void` Success
   */
  updateAvatar = ({ userId, ...query }: UpdateAvatarParams, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/${userId}/updateAvatar`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangePassword
   * @summary Изменение пароля
   * @request POST:/users/changePassword
   * @secure
   * @response `200` `void` Success
   */
  changePassword = (data: ChangePasswordBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/changePassword`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateProfile
   * @summary Обновление профиля
   * @request POST:/users/{userId}/updateProfile
   * @secure
   * @response `200` `void` Success
   */
  updateProfile = (userId: string, data: UpdateProfileBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/users/${userId}/updateProfile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
